import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import SellerDashboard from './pages/SellerDashboard';
import SupervisorDashboard from './pages/SupervisorDashboard';
import Profile from './pages/Profile';
import VerifyOTP from './pages/VerifyOTP';
import ForgotPassword from './pages/ForgotPassword';
import VerifyResetCode from './pages/VerifyResetCode';
import ResetPassword from './pages/ResetPassword';
import Sellers from './pages/Sellers';
import Products from './pages/Products';
import SellerProductsPage from './pages/SellerProductsPage';
import Customers from './pages/Customers';
import SellerCustomersPage from './pages/SellerCustomersPage';
import ExpenseTypes from './pages/ExpenseTypes';
import SupervisorExpenseTypes from './pages/SupervisorExpenseTypes';
import Sales from './pages/Sales';
import SellerSales from './pages/SellerSales';
import SellerSalesType from './pages/SellerSalesType';
import SupervisorSales from './pages/SupervisorSales';
import RegisterExpense from './pages/RegisterExpense';
import SupervisorRegisterExpense from './pages/SupervisorRegisterExpense';
import Reports from './pages/Reports';
import SellerReportsPage from './pages/SellerReportsPage';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-reset-code" element={<VerifyResetCode />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                {/* El componente ProtectedRoute ya tiene acceso al contexto de autenticación */}
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/seller-dashboard" 
            element={
              <ProtectedRoute>
                <SellerDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/supervisor-dashboard" 
            element={
              <ProtectedRoute>
                <SupervisorDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/seller-sales-type" 
            element={
              <ProtectedRoute>
                <SellerSalesType />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/seller-sales" 
            element={
              <ProtectedRoute>
                <SellerSales />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sellers" 
            element={
              <ProtectedRoute>
                <Sellers />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/products" 
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/customers" 
            element={
              <ProtectedRoute>
                <Customers />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/expense-types" 
            element={
              <ProtectedRoute>
                <ExpenseTypes />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/supervisor-expense-types" 
            element={
              <ProtectedRoute>
                <SupervisorExpenseTypes />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sales" 
            element={
              <ProtectedRoute>
                <Sales />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/supervisor-sales" 
            element={
              <ProtectedRoute>
                <SupervisorSales />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/register-expense" 
            element={
              <ProtectedRoute>
                <RegisterExpense />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/supervisor-register-expense" 
            element={
              <ProtectedRoute>
                <SupervisorRegisterExpense />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/seller-products" 
            element={
              <ProtectedRoute>
                <SellerProductsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/seller-customers" 
            element={
              <ProtectedRoute>
                <SellerCustomersPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reports" 
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/seller-reports" 
            element={
              <ProtectedRoute>
                <SellerReportsPage />
              </ProtectedRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
